/**
 * External Dependencies
 */
import 'jquery'; // jQuery

import AOS from 'aos'; // Animate On Scroll
import SmoothScrollTop from 'smooth-scroll-top'; // Smooth Scroll Top
import SimpleParallax from "simple-parallax-js"; // Simple Parallax

import './components/responsive';

import Swiper from 'swiper/bundle'; // Swiper JS
import 'swiper/css/bundle'; // import Swiper styles

/* import mmenu + menu */
import 'mmenu-js';
import './components/menu';

$(() => {
  /**
   * WP Evo Theme version
   */
  console.log('- 💎 WP Evo Theme v0.0.1 - Made with 💗 - ©️ S2i Evolution');

  //////////////////////
  // AXEPTIO //
  /////////////////////

  window._axcb = window._axcb || [];
  window._axcb.push(function(sdk){


    $('.axeptio').on('click touch', function(){
      sdk.openCookies();
    });
  });

  ///////// Init AOS  /////////
  AOS.init({
    //disable: false, // accepts following values: 'phone', 'tablet', 'mobile', boolean, expression or function
    disable: 'mobile',
    once: true,
    animatedClassName: 'aos-animate', // class applied on animation
  });
  console.log('[lib] > Animate On Scroll loaded');

  ///////// Init Smooth Scroll Top  /////////
  const scrollTop = new SmoothScrollTop({
    position: 'right',
    bgColor: '#e63a3f',
  });
  scrollTop.init();
  console.log('[lib] > Smooth Scroll Top loaded');

  check_header();
  $(window).on("scroll", check_header);
  $(window).on("resize", check_header);

  ///////// Init Simple Parallax  /////////
  const simpleParallax = require('simple-parallax-js');

  if($(window).width() > 	1280) {


    var image = document.getElementsByClassName('thumbnail');
    new simpleParallax(image, {
      orientation: 'right',
      overflow: true
    });

    var image_left = document.getElementsByClassName('thumbnail-left');
    new simpleParallax(image_left, {
      orientation: 'left',
      transition: 'cubic-bezier(0,0,0,1)',
      overflow: true
    });
  }

  /// SCROLL ///
  // $('a[href^="#"]').not('.menu-trigger').addClass("scroll");

  $('.scroll').on('click touch', function () { // Au clic sur un élément
    scrollTo(this.hash, 750);
  });

  //$(document).on("scroll", onScroll);

});

function scrollTo(page, speed) {
  $('html, body').animate({ scrollTop: $(page).offset().top - $('header').height() }, speed); // Go
  return false;
}

///// FIXED HEADER /////
function check_header() {
  if ($(window).scrollTop() < 1 && $(window).width() > 992) {
    $("header").removeClass("second_style");
  }
  if ($(window).scrollTop() >= 1 || $(window).width() < 992) {
    $("header").addClass("second_style");
  }
}

///// CLIC SUR LES CARDS /////
$('.card').on('click', function () {
  document.location.href = $(this).find('a').attr('href');
});

///// SWIPE JS /////

const slider = new Swiper('.mySwiper', {
  slidesPerView: 1,
  spaceBetween: 30,
  autoplay: {
    delay: 3000,
    disableOnInteraction: false,
    reverseDirection: false,
    waitForTransition: false,
  },
  loop: true,
  pagination: {
    el: ".swiper-pagination",
    dynamicBullets: true,
    clickable: true,
  },
  navigation: {
    nextEl: ".swiper-button-next",
    prevEl: ".swiper-button-prev",
  },
  // Responsive
  breakpoints: {
    576: {
      slidesPerView: 2,
      spaceBetween: 20,
    },
    768: {
      slidesPerView: 2,
      spaceBetween: 20,
    },
    1024: {
      slidesPerView: 3,
      spaceBetween: 40,
    },
  },
  mousewheel: false,
  keyboard: true,
});

// const sliderPage3 = new Swiper('.swiper3', {
//   slidesPerView: 1,
//   spaceBetween: 30,
//   autoplay: {
//     delay: 3000,
//     disableOnInteraction: false,
//     reverseDirection: false,
//     waitForTransition: false,
//   },
//   loop: true,
//   pagination: {
//     el: ".swiper-pagination",
//     dynamicBullets: true,
//     clickable: true,
//   },
//   navigation: {
//     nextEl: ".swiper-button-next",
//     prevEl: ".swiper-button-prev",
//   },
//   // Responsive
//   breakpoints: {
//     576: {
//       slidesPerView: 2,
//       spaceBetween: 20,
//     },
//     768: {
//       slidesPerView: 2,
//       spaceBetween: 20,
//     },
//     1024: {
//       slidesPerView: 3,
//       spaceBetween: 40,
//     },
//   },
//   mousewheel: false,
//   keyboard: true,
// });

// const sliderPage4 = new Swiper('.swiper4', {
//   slidesPerView: 2,
//   spaceBetween: 30,
//   autoplay: {
//     delay: 3000,
//     disableOnInteraction: false,
//     reverseDirection: false,
//     waitForTransition: false,
//   },
//   loop: true,
//   pagination: {
//     el: ".swiper-pagination",
//     dynamicBullets: true,
//     clickable: true,
//   },
//   navigation: {
//     nextEl: ".swiper-button-next",
//     prevEl: ".swiper-button-prev",
//   },
//   // Responsive
//   breakpoints: {
//     576: {
//       slidesPerView: 3,
//       spaceBetween: 20,
//     },
//     768: {
//       slidesPerView: 4,
//       spaceBetween: 20,
//     },
//     1024: {
//       slidesPerView: 4,
//       spaceBetween: 40,
//     },
//   },
//   mousewheel: false,
//   keyboard: true,
// });

const sliderNumbers = new Swiper('.mySwiperNumbers', {
  slidesPerView: 2,
  spaceBetween: 20,
  autoplay: {
    delay: 3000,
    disableOnInteraction: false,
    reverseDirection: false,
    waitForTransition: false,
  },
  pagination: {
    el: ".swiper-pagination",
    dynamicBullets: true,
    clickable: true,
  },
  navigation: {
    nextEl: ".swiper-button-next",
    prevEl: ".swiper-button-prev",
  },
  // Responsive
  breakpoints: {
    576: {
      slidesPerView: 3,
      spaceBetween: 20,
    },
    768: {
      slidesPerView: 4,
      spaceBetween: 20,
    },
    1024: {
      slidesPerView: 4,
      spaceBetween: 30,
    },
  },
  mousewheel: false,
  keyboard: true,
});

$('.customSwiper').each( function(i) {

  var el = $(this);
  var parent = el.parent();
  var pagi = $(".swiper-pagination")[i];
  var pagiNext = $(".swiper-button-next")[i];
  var pagiPrev = $(".swiper-button-prev")[i];

  if(el.data('dispo') == 3) {
    var customBreak = {
      576: {
        slidesPerView: 2,
        spaceBetween: 20,
      },
      768: {
        slidesPerView: 2,
        spaceBetween: 20,
      },
      1024: {
        slidesPerView: 3,
        spaceBetween: 40,
      },
    };
  } else {
    var customBreak = {
      576: {
        slidesPerView: 3,
        spaceBetween: 20,
      },
      768: {
        slidesPerView: 4,
        spaceBetween: 20,
      },
      1024: {
        slidesPerView: 4,
        spaceBetween: 40,
      },
    };
  }

  var customSlider = new Swiper(el[0], {
    slidesPerView: 1,
    spaceBetween: 30,
    autoplay: {
      delay: 3000,
      disableOnInteraction: false,
      reverseDirection: false,
      waitForTransition: false,
    },
    loop: true,
    pagination: {
      el: pagi,
      dynamicBullets: true,
      clickable: true,
    },
    navigation: {
      nextEl: pagiNext,
      prevEl: pagiPrev,
    },
    // Responsive
    breakpoints: customBreak,
    mousewheel: false,
    keyboard: true,
  });
});


///// HAUTEUR DU CONTENU /////
if ($(window).width() > 1024) {

  // let hauteur_block = document.getElementById('row-height').clientHeight;
  // var x = document.getElementById('item-height');
  // x.style.height = hauteur_block+"px";

//   var hauteur = document.getElementById('row-height').clientHeight;
//   var x = document.getElementsByClassName("item");
//   x.style.height = hauteur+"px";
  //console.log(hauteur_block);
}
